import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BackArrowIcon2, LoginAlpa, New_ScrollX2025, Scrollx_animate, Star_particles } from "../../assets/icons";
import CustomToast, { defaultcustomToatStyle } from "../../Components/CustomToast/CustomToast";
import { forgotPassword, resndOTP, verifyOTP } from "../../Redux/actions/authActions";
import "./resetPassword.css";
import VerifyOTPModal from "./VerifyOtp";
import { CgSpinner } from "react-icons/cg";
import VerifyOTPResetPw from "./VerifyOTPResetPw";

const ResetPassword = ({ path }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setconfirmPassword] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOtpSuccess, setIsOtpSuccess] = useState(false);
  const [otp, setOpt] = useState("");
  const [inValidOtp, setInValidOtp] = useState("");
  const [inValid, setInValid] = useState("");
  const [otpType, setOtpType] = useState("");
  const [submitSuccessLoading, setSubmitSuccessLoading] = useState(false);

  // Get OTP
  const submitHandler = async (e) => {
    setSubmitSuccessLoading(true);
    e.preventDefault();
    try {
      const res = await dispatch(forgotPassword(email));
      if (res?.success) {
        setIsOtpSuccess(true);
        setOtpType(res?.otpType);
        setInValidOtp(" ");
      } else {
        setInValidOtp(res?.response?.data.message);
      }
      setSubmitSuccessLoading(false);
    } catch (error) {
      setSubmitSuccessLoading(false);
    }
  };

  const handleSubmitOtp = async (e) => {
    e.preventDefault();
    if (otp.length === 0) {
      if (!password && !confirmPassword) {
        return (
          setTimeout(() => {
            toast(<CustomToast title={''} content="1 Please enter a 6-digit OTP and both Password field." />, defaultcustomToatStyle,);
          }, 300)
        )
      }

      if (password && !confirmPassword) {
        return (
          setTimeout(() => {
            toast(<CustomToast title={''} content="Please enter a 6-digit OTP and confirmPassword." />, defaultcustomToatStyle,);
          }, 300)
        )
      }

      if (!password && confirmPassword) {
        return (
          setTimeout(() => {
            toast(<CustomToast title={''} content="Please enter a 6-digit OTP and Password." />, defaultcustomToatStyle,);
          }, 300)
        )
      }

      if (password && confirmPassword) {
        return (
          setTimeout(() => {
            toast(<CustomToast title={''} content="Please enter a 6-digit OTP." />, defaultcustomToatStyle,);
          }, 300)
        )
      }

    }
    else if (otp.length > 0) {
      if (otp.length !== 6 || !/^\d{6}$/.test(otp)) {
        return (
          setTimeout(() => {
            toast(<CustomToast title={''} content="Please enter a valid 6-digit OTP." />, defaultcustomToatStyle,);
          }, 300)
        )
      }

      if (!password && !confirmPassword) {
        return (
          setTimeout(() => {
            toast(<CustomToast title={''} content="Both password fields are required." />, defaultcustomToatStyle,);
          }, 300)
        )
      }

      if (!password && confirmPassword) {
        return (
          setTimeout(() => {
            toast(<CustomToast title={''} content="Please enter the new password." />, defaultcustomToatStyle,);
          }, 300)
        )
      }

      if (password && !confirmPassword) {
        return (
          setTimeout(() => {
            toast(<CustomToast title={''} content="Please enter the confirm password." />, defaultcustomToatStyle,);
          }, 300)
        )
      }

      if (password !== confirmPassword) {
        return (
          setTimeout(() => {
            toast(<CustomToast title={''} content="Passwords do not match." />, defaultcustomToatStyle,);
          }, 300)
        )
      }
    }

    if (otp && password === confirmPassword) {
      setSubmitSuccessLoading(true);
      const res = await dispatch(verifyOTP(email, otp, otpType, password));
      // console.log("API Response : ", res);
      if (
        res?.status === 200 &&
        res?.data === "Password updated successfully"
      ) {
        setIsOtpSuccess(false);
        localStorage.removeItem("authToken");
        setOpt("");
        setInValidOtp("");
        setInValid("");
        navigate("/");
        setTimeout(() => {
          toast(<CustomToast title="" content="Password updated successfully !" />, defaultcustomToatStyle,);
        }, 300);
        setSubmitSuccessLoading(false);
      } else if (res?.response?.data?.success === false) {
        // setInValid(res?.response?.data);
        // setTimeout(() => {
        //   setInValid("");
        // }, 5000);
        // navigate("/");
        setTimeout(() => {
          toast(<CustomToast title={res?.response?.data?.error} content="Please enter a valid 6 digit otp." />, defaultcustomToatStyle,);
        }, 300);
        setSubmitSuccessLoading(false);
      }
    }
  };

  const handleResendOtp = async () => {
    const res = await dispatch(resndOTP());
    if (res?.data?.message === "otp Resent successsful") {
      setInValid(`OTP Resent Check Your Mail Agian`);

      setTimeout(() => {
        setInValid("");
      }, 5000);
      toast.error("OTP Resent Check Your Mail Agian.", {
        position: "top-center",
      });
    }
  };

  // Remove token on component mount
  useEffect(() => {
    localStorage.removeItem("authToken");

    const handleBeforeUnload = () => {
      localStorage.removeItem("authToken");
    };

    // Add event listener for page refresh
    window.addEventListener("beforeunload", handleBeforeUnload);

    // Check if token exists on navigation
    const checkAuthToken = () => {
      if (localStorage.getItem("authToken")) {
        localStorage.removeItem("authToken");
      }
    };

    // Run check on component mount
    checkAuthToken();

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <>
      {submitSuccessLoading && (
        <div className="modal-overlayLoader">
          <img
            className="absolute opacity-80"
            src={Scrollx_animate}
            width="120px"
            height="120px"
            alt=""
          />
          <p className="mt-[8rem] text-[0.9rem] text-white">Sending reset link...</p>
        </div>
      )}
      {/* {isOtpSuccess && (
          <VerifyOTPModal
            isOtpSuccess={isOtpSuccess}
            setIsOtpSuccess={setIsOtpSuccess}
            otp={otp}
            setOpt={setOpt}
            handleSubmitOtp={handleSubmitOtp}
            handleResendOtp={handleResendOtp}
            password={password}
            setPassword={setPassword}
            confirmPassword={confirmPassword}
            setconfirmPassword={setconfirmPassword}
            inValid={inValid}
            submitSuccessLoading={submitSuccessLoading}
          />
        )} */}

      {isOtpSuccess && (
        <VerifyOTPResetPw
          isOtpSuccess={isOtpSuccess}
          setIsOtpSuccess={setIsOtpSuccess}
          otp={otp}
          setOpt={setOpt}
          handleSubmitOtp={handleSubmitOtp}
          handleResendOtp={handleResendOtp}
          password={password}
          setPassword={setPassword}
          confirmPassword={confirmPassword}
          setconfirmPassword={setconfirmPassword}
          inValid={inValid}
          submitSuccessLoading={submitSuccessLoading}
        />
      )}

      <div className="resetPWContainer">
        <div className="rpparticles"></div>


        <div className="rpshell">

          <header class="topbar">
            <nav className="w-full flex justify-between">
              <a href="#" className="nav-logo">
                <span className="nav-logo-icon"><img className="logo-img999 " src={New_ScrollX2025} alt="icon" /></span>
                <span>ScrollX</span>
              </a>

              <div className="top-actionslogin">
                <span className=" sm:block">Remember your password?</span>
                <Link to="/login">
                  <span className="text-white sm:block xl:text-[15px] manrope-300 ">Log In</span>
                </Link>
              </div>
            </nav>
          </header>

          <main className="login-page">
            <section className="leftReset">
              <div className="form-wrapReset">
                <p className="eyebrow">Reset Password</p>
                <h1 className="vorp-h1">Get back into<br /><em>your projects.</em></h1>
                <p className="sub">Enter your email and we’ll send a secure reset link.</p>

                <form className="form-card" onSubmit={submitHandler}>
                  <div className="field full">
                    <label for="email" className="vorp-label">Email</label>
                    <input
                      className="vorp-input"
                      id="email"
                      name="email"
                      type="email"
                      placeholder="Enter email ID"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <p className="inValidOtpFP">{inValidOtp ? inValidOtp : null}</p>

                  <button className="submit" type="submit">
                    Send Reset Link <span>→</span>
                    {submitSuccessLoading && (<CgSpinner className="animate-spin text-[1.1rem]" />)}
                  </button>

                  <p className="terms">Check your inbox. The reset link will expire soon.</p>
                  <div className="w-full flex items-center justify-center">
                    <Link to="/login" className="back-link "><span>←</span> Back to login</Link>

                  </div>
                </form>

              </div>
            </section>

            <section className="rightReset">
              <div className="right-inner">
                <div className="value-card">
                  <h2>Your credit work<br /><em>stays right where it is.</em></h2>

                  <div className="feature-list">
                    <div className="feature">
                      <span className="check">
                        <svg viewBox="0 0 16 16" fill="none" stroke-width="2">
                          <path d="M4 8l3 3 5-5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </span>
                      Saved credit projects
                    </div>
                    <div className="feature">
                      <span className="check">
                        <svg viewBox="0 0 16 16" fill="none" stroke-width="2">
                          <path d="M4 8l3 3 5-5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </span>
                      Re-render anytime
                    </div>
                    <div className="feature">
                      <span className="check">
                        <svg viewBox="0 0 16 16" fill="none" stroke-width="2">
                          <path d="M4 8l3 3 5-5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </span>
                      Custom fonts and studio logos
                    </div>
                    <div className="feature">
                      <span className="check">
                        <svg viewBox="0 0 16 16" fill="none" stroke-width="2">
                          <path d="M4 8l3 3 5-5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </span>
                      Major frame rates & formats
                    </div>
                  </div>

                  <div className="settings-mock">
                    <div className="settings-head">
                      <span>Project Scroll Speed</span>
                      <span className="settings-badge">Saved</span>
                    </div>
                    <div className="settings-body">
                      <div className="settings-panel">
                        <div className="setting-row">
                          <div className="setting-label">Template</div>
                          <div className="setting-box">Modern Roll <span>▾</span></div>
                        </div>
                        <div className="setting-row">
                          <div className="setting-label">Font</div>
                          <div className="setting-box">Helvetica Neue <span>▾</span></div>
                        </div>
                        <div className="setting-row">
                          <div className="setting-label">Alignment</div>
                          <div className="align-mini"><div>≡</div><div className="active">≡</div><div>≡</div></div>
                        </div>
                        <div className="setting-row">
                          <div className="setting-label">Scroll Speed</div>
                          <div className="speed-track"></div>
                        </div>
                      </div>

                      <div className="settings-preview">
                        <div className="preview-credit">
                          <span className="role">Edited by</span>
                          <span className="name">ZOE CARTER</span>
                          <span className="meta">4K · 23.98fps</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="noteFP">
                    <div className="avatarFP">SX</div>
                    <div>Your credit rolls, fonts, logos, and exports stay organized in one place.<strong>42 px/sec for last-minute changes</strong></div>
                  </div>
                </div>
              </div>
            </section>
          </main>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
